import script from "./WCAddToCartQuantityAdjusterModernCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCAddToCartQuantityAdjusterModernCard.vue?vue&type=script&setup=true&lang=ts"

import "./WCAddToCartQuantityAdjusterModernCard.vue?vue&type=style&index=0&id=2453fe00&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2453fe00"]])

export default __exports__